class OurStoryTimeline extends HTMLElement {
  connectedCallback() {
    this.#init();
  }

  #init() {
    const { animate, scroll } = Motion;

    const container = this.querySelector("[data-timeline-container]");
    const progressLine = this.querySelector("[data-timeline-progress]");
    const timelineItems = this.querySelectorAll(".timeline-item");

    if (!container || !progressLine || !timelineItems.length) return;

    // Animate the progress line as user scrolls through the section
    scroll(animate(progressLine, { scaleY: [0, 1] }), {
      target: container,
      offset: ["start 0.6", "end 0.6"],
    });

    // Animate each timeline item's images when they come into view
    for (const item of timelineItems) {
      const images = item.querySelectorAll(".timeline-image");
      const text = item.querySelector(".timeline-item__text");

      const yearDot = item.querySelector(".timeline-item__year-dot");
      if (yearDot) {
        scroll(animate(yearDot, { backgroundColor: ["#9fafae", "#c74755"] }), {
          target: yearDot,
          offset: ["start 0.6", "start 0.59"],
        });
      }

      if (text) {
        scroll(
          animate(
            text,
            {
              opacity: [0, 1],
              scale: [0.9, 1],
              y: [12, 0],
            },
            {
              duration: 0.5,
              easing: "ease-out",
            }
          ),
          {
            target: text,
            offset: ["start 0.6", "start 0.58"],
          }
        );
      }

      if (!images.length) continue;

      for (const image of images) {
        const rotate =
          parseInt(image.style.getPropertyValue("--img-rotation")) || 0;
        const startRotate = rotate < 0 ? rotate + 5 : rotate - 5;
        scroll(
          animate(
            image,
            {
              scale: [0.9, 1],
              opacity: [0, 1],
              rotate: [startRotate, rotate],
            },
            {
              duration: 0.6,
              easing: "ease-out",
            }
          ),
          {
            target: image,
            offset: ["start 0.7", "start 0.6"],
          }
        );
      }
    }
  }
}

if (!customElements.get("our-story-timeline")) {
  customElements.define("our-story-timeline", OurStoryTimeline);
}
